import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Company } from 'src/lib/loadCompanies'

const initialState: Company = {
    id: '',
    name: '',
    email: null,
    chargingCount: 0,
    offlineCount: 0,
    onlineCount: 0,
    ownerReadOnly: false,
    partnerId: 0,
    partnerName: '',
    externalId: '',
}

export const chargePointsSlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        setCompany: (_, action: PayloadAction<Company>) => {
            return action.payload
        },
    },
})

export const { setCompany } = chargePointsSlice.actions

export default chargePointsSlice.reducer
